import { render, staticRenderFns } from "./oauth_login_page.vue?vue&type=template&id=a500df70"
import script from "./oauth_login_page.vue?vue&type=script&lang=js"
export * from "./oauth_login_page.vue?vue&type=script&lang=js"
import style0 from "./oauth_login_page.vue?vue&type=style&index=0&id=a500df70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports